import { useRouter } from "next/router";
import React from "react";

import { Button } from "@/components/atoms/buttons/Button";
import { useIsLoggedIn } from "@/states/auth/selectors";

export const ToTopButton = () => {
  const router = useRouter();
  const isLoggedIn = useIsLoggedIn();
  return (
    <Button
      label="TOPページへ"
      className="w-[200px] h-[50px] text-sm text-white bg-[#45BEAB] rounded-[8px]"
      onClick={async () => {
        await router.push(isLoggedIn ? "/mypage" : "https://yoyacoo.jp/");
      }}
    />
  );
};
